@if (form(); as form) {
  <fieldset [formGroup]="form">
    <legend>Kierownik robót</legend>
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerFirstName" as controlName'>
          <label [for]='controlName'>
            Imię/Imiona *
          </label>
          <input
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu imię/imiona'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerLastName" as controlName'>
          <label [for]='controlName'>
            Nazwisko *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwisko'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerPhone" as controlName'>
          <label [for]='controlName'>
            Numer telefonu *
          </label>
          <input
            mask='0*'
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu numer telefonu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerEmail" as controlName'>
          <label [for]='controlName'>
            E-mail
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu e-mail'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerPostalCode" as controlName'>
          <label [for]='controlName'>
            Kod pocztowy *
          </label>
          <input
            [id]='controlName'
            mask='00-000'
            [dropSpecialCharacters]='false'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu kod pocztowy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerPostOffice" as controlName'>
          <label [for]='controlName'>
            Poczta *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu pocztę'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerCity" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu miejscowość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"managerStreet" as controlName'>
          <label [for]='controlName'>
            Ulica
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę ulicy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"managerBuildingNumber" as controlName'>
          <label [for]='controlName'>
            Nr domu *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr domu'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-2'>
        <div class='form-group' *ngIf='"managerHouseNumber" as controlName'>
          <label [for]='controlName'>
            Nr mieszkania
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nr mieszkania'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </fieldset>
}
